import React from 'react';
import { Mask } from 'antd-mobile';
import { useTranslation } from 'react-i18next';

import {
  ImgMaskCloseIcon,
  ImgMaskDownloadIcon,
  ImgMaskLeftIcon,
  ImgMaskRightIcon,
} from '@whelk/assets/src/web/common-icons';

import './style.scss';

const WebImgMask = ({
  open,
  onClose,
  imgMaskUrlList,
  currentImgIndex,
  isLongMoreThanWide,
  setCurrentImgIndex,
  onClickDownLoadImg,
}: {
  open: boolean;
  onClose: () => void;
  imgMaskUrlList: string[];
  currentImgIndex: number;
  isLongMoreThanWide: boolean;
  onClickDownLoadImg: () => void;
  setCurrentImgIndex: (index: number) => void;
}) => {
  const { t } = useTranslation();
  const imgUrl = imgMaskUrlList[currentImgIndex];
  const imgNum = imgMaskUrlList.length;

  return (
    <Mask destroyOnClose visible={open} onMaskClick={onClose} className='share-img-mask'>
      <div
        className='relative h-[var(--screen)] w-full p-[16px] md:px-[100px]  md:py-[20px]'
        id='mask'
        onClick={(e: any) => {
          const targetEl = document.getElementById('mask');
          if (targetEl === e.target) {
            onClose();
          }
        }}
      >
        {/* 关闭按钮 */}
        <div
          className={`absolute right-10 top-10 flex justify-end md:cursor-pointer`}
          onClick={onClose}
        >
          <ImgMaskCloseIcon />
        </div>
        {/* 图片 */}
        <div
          className={`absolute left-[50%] top-[50%] flex h-[70%] w-[70%] items-center ${
            isLongMoreThanWide ? 'max-w-[600px]' : 'max-h-[600px]'
          }`}
          style={{ transform: 'translate(-50%, -50%)' }}
        >
          {open && (
            <img
              src={imgUrl}
              draggable='false'
              alt='hailuo-img-viewer'
              id='mask-img-content'
              className={`h-[100%] w-[100%]  ${
                isLongMoreThanWide ? 'max-w-[600px]' : 'max-h-[600px]'
              } overflow-hidden  rounded-[12px] object-contain`}
              onClick={onClose}
            />
          )}
        </div>
        {/* 切换 */}
        {imgNum > 1 && (
          <>
            <div
              className='absolute left-4 top-[50%] h-11 translate-y-[-50%]'
              onClick={() => {
                if (currentImgIndex === 0) return;
                setCurrentImgIndex(currentImgIndex - 1);
              }}
            >
              <ImgMaskLeftIcon />
            </div>
            <div
              className='absolute right-4 top-[50%] h-11 translate-y-[-50%]'
              onClick={() => {
                if (currentImgIndex === imgNum - 1) return;
                setCurrentImgIndex(currentImgIndex + 1);
              }}
            >
              <ImgMaskRightIcon />
            </div>
          </>
        )}
        {/* 进度条 */}
        {imgNum > 1 && (
          <div
            className={' absolute bottom-[128px] left-[50%] flex translate-x-[-50%] justify-center'}
          >
            {Array(imgNum)
              .fill(null)
              .map((_, index) => (
                <div
                  key={index}
                  className={`inline-block h-[6px] w-[6px] cursor-pointer rounded-[50%] ${
                    index !== 0 && 'ml-[6px]'
                  } ${currentImgIndex === index ? 'bg-pri_light' : 'bg-[#FFFFFF33]'}`}
                  onClick={() => setCurrentImgIndex(index)}
                ></div>
              ))}
          </div>
        )}
        {/* 下载原图 */}
        <div
          className='bg-col_accent05 absolute bottom-[48px] left-[50%] flex translate-x-[-50%] cursor-pointer items-center rounded-[8px] px-5 py-3 md:hover:bg-[#FFFFFF4C]'
          onClick={onClickDownLoadImg}
        >
          <ImgMaskDownloadIcon />
          <span className='text-col_accent04 shadow-s1 ml-1 whitespace-nowrap text-[14px] leading-[20px]'>
            {t('download_img')}
          </span>
        </div>
      </div>
    </Mask>
  );
};

export default WebImgMask;
